//@flow
// npm imports
import React, { PureComponent } from 'react';

// local imports
import './Alert.css';

// types
export type StateProps = {
  showAlertInfo: string,
  message_alerte: string,
};

export type DispatchProps = {
  closeAlertInfo: (raw: string) => void
};

type Props = StateProps & DispatchProps;

// components
class Alert extends PureComponent<Props> {
  render() {
    const { message_alerte } = this.props;

    if ((!this.props.showAlertInfo || this.props.showAlertInfo !== message_alerte) && message_alerte !== '') {
      return (
        <div className="warning">
          <div className="warning__wrapper">
            <i className="icon icon-close" onClick={() => this.props.closeAlertInfo(message_alerte)}></i>
						<p dangerouslySetInnerHTML={{__html: message_alerte}}></p>
          </div>
        </div>
      );
		};

    return null;
  };
};
 
export default Alert;